export function RejectIcon() {
	return (
		<svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d={`M6 7.77757L1.52852 12.2491C1.36122 12.4164 1.14829 12.5 0.889734 12.5C0.631179 12.5 0.418251 
                    12.4164 0.250951 12.2491C0.0836502 12.0817 0 11.8688 0 11.6103C0 11.3517 0.0836502 11.1388 
                    0.250951 10.9715L4.72243 6.5L0.250951 2.02852C0.0836502 1.86122 0 1.64829 0 1.38973C0 1.13118 
                    0.0836502 0.918251 0.250951 0.750951C0.418251 0.58365 0.631179 0.5 0.889734 0.5C1.14829 0.5 
                    1.36122 0.58365 1.52852 0.750951L6 5.22243L10.4715 0.750951C10.6388 0.58365 10.8517 0.5 11.1103 
                    0.5C11.3688 0.5 11.5817 0.58365 11.7491 0.750951C11.9164 0.918251 12 1.13118 12 1.38973C12 
                    1.64829 11.9164 1.86122 11.7491 2.02852L7.27757 6.5L11.7491 10.9715C11.9164 11.1388 12 11.3517 
                    12 11.6103C12 11.8688 11.9164 12.0817 11.7491 12.2491C11.5817 12.4164 11.3688 12.5 11.1103 
                    12.5C10.8517 12.5 10.6388 12.4164 10.4715 12.2491L6 7.77757Z`}
				fill="#585B6D"
			/>
		</svg>
	);
}
